<template>
    <div id="complete">
        <Header />
        <div class="complete_box">
            <img src="../assets/images/img_email.svg" alt="이메일 인증 완료">
            <div class="complete_btn"></div>
        </div>
        <Footer />
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'Home',
        pageCategory: '',
        components: {
            Header,
            Footer,
    }
}
</script>